export function main (_p5) {
  let p5
  p5 = _p5
  let parentWidth, parentHeight
  let dim
  let img, mono
  let imgMax, imgMin, shorterEdge
  let num = 7
  let up = []
  let lp = []
  p5.preload = () => {
    const parentDiv = document.getElementById('purification-canvas-wrapper')
    parentWidth = parentDiv.offsetWidth
    parentHeight = parentDiv.offsetHeight
    dim = Math.min(parentWidth, parentHeight)
    img = p5.loadImage('../static/purification-images/purification-col.jpg')
    mono = p5.loadImage('../static/purification-images/purification-mono.jpg')
  }
  p5.setup = _ => {
    p5.frameRate(60)
    imgMax = Math.max(img.width, img.height)
    imgMin = Math.min(img.width, img.height)
    shorterEdge = (dim / imgMax) * imgMin
    if (imgMax === img.width) {
      img.resize(dim, (dim / imgMax) * imgMin)
      mono.resize(dim, (dim / imgMax) * imgMin)
      const canvas = p5.createCanvas(dim, shorterEdge)
      canvas.parent('Purification-canvas')
      p5.image(mono, 0, 0, dim, shorterEdge)
    } else if (imgMax === img.height) {
      img.resize((dim / imgMax) * imgMin, dim)
      mono.resize((dim / imgMax) * imgMin, dim)
      const canvas = p5.createCanvas(shorterEdge, dim)
      canvas.parent('Purification-canvas')
      p5.image(mono, 0, 0, shorterEdge, dim)
    }
    for (let i = 0; i < num; i++) {
      up[i] = new UpperPointer()
      lp[i] = new LowerPointer()
    }
  }

  p5.draw = () => {
    for (let i = 0; i < num; i++) {
      up[i].update()
      up[i].display()
      lp[i].update()
      lp[i].display()
    }
    if (up[0].position.y === img.height) {
      p5.noLoop()
    }
  }
  class UpperPointer {
    constructor () {
      this.position = p5.createVector(p5.random(img.width), 0)
      this.xoff = 0.1
      this.xstep = 0
      this.seed = p5.random(10)
      this.col = img.get(this.position.x, this.position.y)
      this.interval = 3.5
    }
    update () {
      p5.noiseSeed(this.seed)
      let nx = p5.noise(this.xoff)
      if (nx > 0.6) {
        this.xstep = 1
      } else if (nx < 0.4) {
        this.xstep = -1
      }
      this.position.add(this.xstep, 1)
      this.xoff += 0.01
      this.xstep = 0
    }
    display () {
      for (let i = 0; i < 13; i++) {
        p5.noStroke()
        this.col = img.get(this.position.x + i * this.interval, this.position.y)
        p5.fill(this.col)
        p5.ellipse(this.position.x + i * this.interval, this.position.y, 1.5)
      }
    }
  }
  class LowerPointer {
    constructor () {
      this.position = p5.createVector(p5.random(img.width), img.height)
      this.xoff = 0.8
      this.xstep = 0
      this.seed = p5.random(10)
      this.col = img.get(this.position.x, this.position.y)
      this.interval = 3.5
    }
    update () {
      p5.noiseSeed(this.seed)
      let nx = p5.noise(this.xoff)
      if (nx > 0.6) {
        this.xstep = 1
      } else if (nx < 0.4) {
        this.xstep = -1
      }
      this.position.add(this.xstep, -1)
      this.xoff += 0.01
      this.xstep = 0
    }
    display () {
      for (let i = 0; i < 13; i++) {
        p5.noStroke()
        this.col = img.get(this.position.x + i * this.interval, this.position.y)
        p5.fill(this.col)
        p5.ellipse(this.position.x + i * this.interval, this.position.y, 1.5)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/Purification.js